import { useAuthContext } from '@/context/auth/useAuthContext';
import { VStack, Link as ChakraLink, HStack, Text, Spinner } from '@chakra-ui/react';
import React, { useState } from 'react';
import { memberCareRoleMenuOptions } from '../options';
import { Link, useRouter } from '@tanstack/react-router';
import menuMessages from '@/messages/menu';

interface Props {
  onPressCallback?: () => void;
}

const ProfileMenu = ({ onPressCallback = () => {} }: Props) => {
  const { isMemberCare, signOut } = useAuthContext();
  const [isSigningOut, setIsSigningOut] = useState(false);

  const {
    state: {
      location: { pathname },
    },
  } = useRouter();

  const isOnboarding = pathname.includes('/onboarding');

  // Note: If it is onboarding flo, alow user only to sign out
  const menuOptions = isOnboarding ? [] : isMemberCare ? memberCareRoleMenuOptions : [];

  // signOut navigates to /sign-in itself, before clearing state, and cannot throw
  // — so there is nothing to await around and nothing to recover from. The
  // spinner is not reset: this component unmounts with the sign-out.
  const handleSignOut = () => {
    if (isSigningOut) return;

    setIsSigningOut(true);
    onPressCallback();
    signOut();
  };

  return (
    <VStack padding={'20px'} alignItems={'flex-end'}>
      {menuOptions.map((option, index) => {
        const isActiveRoute = pathname === option.navigateTo;
        return (
          <ChakraLink
            as={Link}
            key={`${index}-${option.label}`}
            onClickCapture={() => {
              onPressCallback();
            }}
            to={option.navigateTo}
            textAlign={'right'}
            fontWeight={'600'}
            color={isActiveRoute ? 'primary.500' : 'text.mediumBlue'}
          >
            {option.label}
          </ChakraLink>
        );
      })}
      <HStack
        _hover={{ cursor: isSigningOut ? 'default' : 'pointer' }}
        aria-busy={isSigningOut}
        onClick={isSigningOut ? undefined : handleSignOut}
      >
        {isSigningOut ? (
          <Spinner size={'sm'} color={'text.mediumGray'} />
        ) : (
          <Text color={'text.mediumGray'}>{menuMessages.signOut}</Text>
        )}
      </HStack>
    </VStack>
  );
};

export default ProfileMenu;
